import React, { FC, useCallback } from 'react';
import styles from './index.module.scss';
import { AdvancedSettings } from './AdvancedSettings';
import KeywordsArea from './KeywordsArea';
import { Skeleton } from 'src/common';
import { Trans, useTranslation } from 'react-i18next';
import OffsetAnchor from '../OffsetAnchor';
import { useLoadMp } from 'src/models/matchingProfiles/hooks';
import { trackMPEditKeywordShortcut } from 'src/segment/events';
import { Description } from 'src/shared';

interface IProps {
  disabled: boolean;
}

export const Keywords: FC<IProps> = props => {
  const { disabled } = props;
  const { t } = useTranslation();
  const { data: mp, loading } = useLoadMp();
  const mpId = mp?.id;
  const keywords = mp?.keywords || [];

  const onPressEnter = useCallback(() => {
    if (mp) {
      trackMPEditKeywordShortcut({ id: mp.id, name: mp.name });
    }
  }, [mp]);

  return loading ? (
    <Skeleton loading active />
  ) : (
    <div className={styles.preferencesKeywords}>
      <div className={styles.titleContainer}>
        <OffsetAnchor id={'keywords'} />
        <Description>
          <p>{t('Tenders.keywordsFilteringDescriptionPart1')}</p>
          <Trans
            i18nKey={'Tenders.keywordsFilteringDescriptionPart2'}
            components={{
              1: <span className={styles.bold}></span>
            }}
            parent={'p'}
          />
          <Trans
            i18nKey={'Tenders.keywordsFilteringDescriptionPart3'}
            components={{
              1: <span className={styles.bold}></span>
            }}
            parent={'p'}
          />
        </Description>
      </div>
      {mpId && (
        <div className={styles.keywords}>
          <KeywordsArea
            disabled={disabled}
            keywords={keywords}
            withPreview
            mpId={mpId}
            mpName={mp.name}
            onPressEnter={onPressEnter}
          />
          <div className={styles.container}>
            <AdvancedSettings disabled={disabled} keywords={keywords || []} mpId={mpId} mpName={mp.name} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Keywords;
